const state = {
  filterChange: false,
};

const mutations = {
  emitFilterChanged(state, status) {
    state.filterChange = status;
  },
};

const getters = {
  getFilterChange: (state) => state.filterChange,
};

export default {
  state,
  mutations,
  getters
}
